
import React, { useRef }from 'react'
import {Login} from '../components/Login'
import {createUserWithEmailAndPassword} from 'firebase/auth'
import {auth} from '../utils/firebase'
import { setDoc, doc } from 'firebase/firestore'
import  db   from '../utils/firebase'

function SignUp() {
    const emailRef = useRef()
    const password = useRef()

    const register = async ()=>{
        try{
            //create a user with firebase authentication
            await createUserWithEmailAndPassword(auth, emailRef.current.value,password.current.value)
            .then(async (cred)=>{
                //create a user document to the users collection
                console.log(cred.user.uid)
                await setDoc(doc(db,"Users",`${cred.user.uid}`) , {
                    //payload of how your data should be structured
                    tasks: [
                        

                    
                ]


                })
                //after succesfully creating user we send them to dash
                if(cred){
                 window.location = "/dashboard"
                }
            })
            
            
            
           
        }
        catch(error){
            alert(error.message)

        }

    }
  return (
    <div>
        <Login
          title = "Sign up"
          button = "Sign up"
          href = "/"
          link = "Sign in"
          headerStatement = "Already have an account?"
          emailInput = {emailRef}
          passwordInput = {password}
          btnFunction = {register}
          />

    </div>
  )
}

export default SignUp